var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-card"},[(_vm.image)?_c('div',{staticClass:"action-card__image"},[_c('img',{attrs:{"src":_vm.image}})]):_vm._e(),_c('div',{staticClass:"action-card__text"},[_c('p',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }